<template>
    <div class="d-inline-block ml-1">
        <b-button variant="warning" @click.stop="abrirModalDeflator()">
            <span>
                <i class="fa fa-arrow-down mr-2"></i> Deflator
            </span>
        </b-button>

        <b-modal
            id="modalDeflatorContrato"
            v-model="mostrarModalDeflator"
            @show="aoAbrirModal()"
            @hidden="reset()"
        >
            <div slot="modal-title">
                Deflator do Contrato -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>

            <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>

            <b-row>
                <b-col sm="12">
                    <b-form-group :state="$v.valorDeflator.$dirty ? !$v.valorDeflator.$invalid : null"
                    invalid-feedback="Informe um valor válido maior que zero.">
                        <label class="required">Valor do Deflator</label>
                        <money
                            v-model="valorDeflator"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valorDeflator.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModalDeflator()">
                    Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    class="ml-1"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvarDeflator()"
                >
                    Salvar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import ContratosServicos from './ContratosServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalDeflator: false,
            operacao: 'ATUALIZAÇÃO',
            erros: [],
            valorDeflator: 0,

            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$dirty && this.$v.$invalid
        }
    },

    methods: {
        abrirModalDeflator() {
            this.reset()
            const saldo = (this.contrato && this.contrato.saldoContratoAnterior)
                ? Number(this.contrato.saldoContratoAnterior)
                : 0

            this.valorDeflator = saldo > 0 ? saldo : 0

            this.mostrarModalDeflator = true
        },

        aoAbrirModal() {
            this.$nextTick(() => {
            if (this.$v && this.$v.valorDeflator) {
                this.$v.valorDeflator.$touch()
            }
            })
        },

        fecharModalDeflator() {
            this.mostrarModalDeflator = false
        },

        reset() {
            this.erros = []
            this.valorDeflator = 0

            if (this.$v) {
                this.$nextTick(() => this.$v.$reset())
            }
        },

        confirmarSalvarDeflator() {
            this.$v.$touch()
            if (this.$v.$invalid) return

            this.$swal({
                title: 'Deflator',
                html: `Confirma salvar o deflator do contrato <b>${this.contrato.vcCodigoEstruturado}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvarDeflator()
                }
            })
        },

        salvarDeflator() {
            this.$store.dispatch('addRequest')

            const valorPositivo = Number(this.valorDeflator) || 0
            const dto = { valorDeflator: valorPositivo }

            ContratosServicos.atualizarDeflatorContrato(this.contrato.idContrato, dto)
                .then((response) => {
                    if(!response) return
                    
                    if (response.success) {
                      this.$toast.success(
                        'Deflator aplicado no Contrato com sucesso. Verifique e atualize os valores dos itens ou das fases, se necessário.',
                        'OK',
                        this.$toastConfig.success)

                      this.$emit('obterContratoAtualizado', true)
                      this.$emit('atualizarMensagensErros', [])
                      this.mostrarModalDeflator = false
                    } else {
                      this.erros = response.errors
                      this.$emit('atualizarMensagensErros', this.erros)
                    }
                })
                .finally(() => {
                this.$store.dispatch('removeRequest')
                })
            }
    },

    validations: {
        valorDeflator: {
            required,
            minValue: minValue(0.01)
        }
    }
}
</script>
